const standalone = () => matchMedia('(display-mode: standalone)').matches;

export default standalone ;
